module.exports = __webpack_public_path__ + "6736f9838e3c0ddc74089074f9397bae.svg";